module.exports = __webpack_public_path__ + "img/face4.fd4ef4c5.png";